const MAX_QR_BYTES = 1024 * 1024;
const QR_TYPES = { 'image/png': 'png', 'image/jpeg': 'jpg', 'image/webp': 'webp' };
function normalizeVoicePayment(input) {
  if (input === undefined || input?.method === 'later') return { method: 'later' };
  if (!input || typeof input !== 'object' || Array.isArray(input)) throw Error('支払先の入力内容を確認してください。');
  if (input.method === 'bank') {
    const bank = {};
    for (const [key, max] of Object.entries({ bankName: 100, branchName: 100, accountHolder: 120 })) {
      const value = input[key];
      if (typeof value !== 'string' || !value.trim() || value.trim().length > max || /[\r\n]/.test(value)) throw Error('銀行名・支店名・口座名義を入力してください。');
      bank[key] = value.trim();
    }
    if (!['ordinary', 'current', 'savings'].includes(input.accountType)) throw Error('口座種別を選択してください。');
    if (typeof input.accountNumber !== 'string' || !/^\d{7}$/.test(input.accountNumber)) throw Error('口座番号は7桁の半角数字で入力してください。');
    return { method: 'bank', ...bank, accountType: input.accountType, accountNumber: input.accountNumber };
  }
  if (input.method === 'paypay') {
    const qr = input.qr;
    if (!qr || !Object.hasOwn(QR_TYPES, qr.contentType) || typeof qr.data !== 'string' || !qr.data) throw Error('PayPayのQRコード画像（PNG・JPEG・WebP）を添付してください。');
    if (qr.data.length > Math.ceil(MAX_QR_BYTES / 3) * 4) throw Error('QRコード画像は1MB以下にしてください。');
    if (!/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(qr.data)) throw Error('QRコード画像のデータが不正です。');
    let bytes;
    try { bytes = atob(qr.data); } catch { throw Error('QRコード画像のデータが不正です。'); }
    if (bytes.length > MAX_QR_BYTES) throw Error('QRコード画像は1MB以下にしてください。');
    const valid = qr.contentType === 'image/png' ? bytes.startsWith('\x89PNG\r\n\x1a\n')
      : qr.contentType === 'image/jpeg' ? bytes.startsWith('\xff\xd8\xff')
        : bytes.startsWith('RIFF') && bytes.slice(8, 12) === 'WEBP';
    if (!valid) throw Error('画像の形式を確認して、PNG・JPEG・WebPの画像を添付してください。');
    return { method: 'paypay', qr: { contentType: qr.contentType, data: qr.data, filename: `paypay-qr.${QR_TYPES[qr.contentType]}` } };
  }
  throw Error('支払方法を選択してください。');
}
function voicePaymentText(payment) {
  if (payment.method === 'bank') return [
    '支払方法: 銀行振込', `銀行名: ${payment.bankName}`, `支店名: ${payment.branchName}`,
    `口座種別: ${{ ordinary: '普通', current: '当座', savings: '貯蓄' }[payment.accountType]}`,
    `口座番号: ${payment.accountNumber}`, `口座名義（カナ）: ${payment.accountHolder}`,
  ].join('\n');
  if (payment.method === 'paypay') return `支払方法: PayPay\nQRコード画像: ${payment.qr.filename}（メールに添付）`;
  return '支払先: 依頼成立後に連絡';
}
module.exports = { MAX_QR_BYTES, QR_TYPES, normalizeVoicePayment, voicePaymentText };
